import "./telegram-web-apps";
var telegramWindow = window;
export var WebApp = telegramWindow.Telegram.WebApp;
//# sourceMappingURL=sdk.js.map